import { useRefresh } from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import { closeDialog } from '@/store/slices/dialog';
import { OnCloseKey } from '@/store/slices/dialog/types';

const useController = () => {
  const refresh = useRefresh();
  const dispatch = useDispatch();
  const { dialogMessage, dialogTitle, isDialogOpen, onCloseKey } = useSelector((state: RootState) => state.dialog);

  const ON_CLOSE_KEY_TO_ACTION: Record<OnCloseKey, () => void> = {
    refresh_page: () => refresh(),
  };

  const doAction = () => ON_CLOSE_KEY_TO_ACTION?.[onCloseKey]?.();

  const onCloseDialog = () => {
    dispatch(closeDialog());
    onCloseKey && doAction();
  };

  return {
    dialogMessage,
    dialogTitle,
    isDialogOpen,
    onCloseDialog,
  };
};

export default useController;
